<template>
    <el-button
    type="primary"
    size="mini"
    icon="el-icon-download"
    @click="handleCsvDownload"
    style="margin-right: 10px;"
    :loading="downloadingCsv">
    {{$t('common.csv')}}
    </el-button>
</template>

<script>
import { CHARGE_CODE_LIST_CSV } from '@/store/actions';

export default {
  name: 'DownloadCsv',
  data() {
    return {
      downloadingCsv: false,
    };
  },
  methods: {
    handleCsvDownload() {
      this.downloadingCsv = true;
      this.$store.dispatch(CHARGE_CODE_LIST_CSV)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          // Updated to xlsx
          link.setAttribute('download', 'charge_codes_report.xlsx');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.downloadingCsv = false;
        })
        .catch(() => {
          this.downloadingCsv = false;
        });
    }
  },
};

</script>
